export default {"src":"https://dap-qexpkq5xj-dap-rewrite.vercel.app/_next/static/media/error_icon.70f1c5f2.svg","height":16,"width":16};